export enum SaleSendToKsefValidationWarning {
    PdfAlreadyGenerated = 'PdfAlreadyGenerated',
    DocumentWithPastIssueDateWillBeOffline = 'DocumentWithPastIssueDateWillBeOffline',
    DocumentItemsWithTooLongSymbol = 'DocumentItemsWithTooLongSymbol',
    DocumentItemsWithTooLongBarCode = 'DocumentItemsWithTooLongBarCode'
}
